// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SearchBar.css */

.searchbar-container {
    position: relative;
    width: 100%;
    max-width: 800px;       /* İsteğe bağlı olarak maksimum genişlik */
    margin: 0 auto;         /* Ortalamak için */
    padding: 0 20px;        /* Kenarlardan boşluk bırakmak için */
    box-sizing: border-box;
}

.search-input {
    width: 100%;
    height: 56px;           /* Yüksekliği ayarlıyoruz */
    padding: 0 115px 0 20px; /* Soldan ve sağdan iç boşluklar */
    border: 2px solid #3c4f58;
    border-radius: 8px;
    font-size: 16px;
    box-sizing: border-box;
}

.search-input:focus {
    outline: none;
    border-color: #b5b5b5;
    box-shadow: 0 0 0 2px rgb(0, 60, 79);
}

/* İkon genel stili: slider ve search zaten mutlak konumlu */
.slider-icon,
.search-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
    cursor: pointer;
    font-size: 24px;
}

/* Slider (ayarlar) ikonu sağdan 70px boşluk */
.slider-icon {
    right: 70px;
}

/* Search (arama) ikonu sağdan 35px boşluk */
.search-icon {
    right: 35px;
}

/* Yeni: upload ikonu da mutlak konumlu ve dikey ortalanmış */
.search-icons .upload-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
    cursor: pointer;
    font-size: 24px;
}

/* Upload ikonu sağdan 110px boşluk (Slider’ın solunda olacak şekilde) */
.upload-icon {
    right: 110px;
}

/* Aktif (paneli açık) hâlinde ikon rengi */
.search-icons .upload-icon.active,
.search-icons .slider-icon.active,
.search-icons .search-icon.active {
    color: #007bff;
}


/* Responsive Ayarlar */
@media (max-width: 768px) {
    .searchbar-container {
        padding: 0 15px;
    }

    .search-input {
        height: 48px;
        font-size: 14px;
        padding: 0 50px 0 15px;
    }

    .slider-icon,
    .search-icon,
    .upload-icon {
        font-size: 20px;
    }

    .slider-icon {
        right: 50px;
    }

    .upload-icon {
        right: 90px;  /* Responsive hâlinde biraz daha sola kaydırdık */
    }

    .search-icon {
        right: 15px;
    }
}

@media (max-width: 480px) {
    .searchbar-container {
        padding: 0 10px;
    }

    .search-input {
        height: 40px;
        font-size: 14px;
        padding: 0 45px 0 10px;
    }

    .slider-icon,
    .search-icon,
    .upload-icon {
        font-size: 18px;
    }

    .slider-icon {
        right: 45px;
    }

    .upload-icon {
        right: 75px;  /* Mobilde daha solda */
    }

    .search-icon {
        right: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchBar/SearchBar.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB,QAAQ,0CAA0C;IAClE,cAAc,UAAU,mBAAmB;IAC3C,eAAe,SAAS,qCAAqC;IAC7D,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY,YAAY,2BAA2B;IACnD,uBAAuB,EAAE,kCAAkC;IAC3D,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA,4DAA4D;AAC5D;;IAEI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,8CAA8C;AAC9C;IACI,WAAW;AACf;;AAEA,4CAA4C;AAC5C;IACI,WAAW;AACf;;AAEA,6DAA6D;AAC7D;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA,wEAAwE;AACxE;IACI,YAAY;AAChB;;AAEA,2CAA2C;AAC3C;;;IAGI,cAAc;AAClB;;;AAGA,uBAAuB;AACvB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,sBAAsB;IAC1B;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW,GAAG,iDAAiD;IACnE;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,sBAAsB;IAC1B;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW,GAAG,uBAAuB;IACzC;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":["/* SearchBar.css */\r\n\r\n.searchbar-container {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: 800px;       /* İsteğe bağlı olarak maksimum genişlik */\r\n    margin: 0 auto;         /* Ortalamak için */\r\n    padding: 0 20px;        /* Kenarlardan boşluk bırakmak için */\r\n    box-sizing: border-box;\r\n}\r\n\r\n.search-input {\r\n    width: 100%;\r\n    height: 56px;           /* Yüksekliği ayarlıyoruz */\r\n    padding: 0 115px 0 20px; /* Soldan ve sağdan iç boşluklar */\r\n    border: 2px solid #3c4f58;\r\n    border-radius: 8px;\r\n    font-size: 16px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.search-input:focus {\r\n    outline: none;\r\n    border-color: #b5b5b5;\r\n    box-shadow: 0 0 0 2px rgb(0, 60, 79);\r\n}\r\n\r\n/* İkon genel stili: slider ve search zaten mutlak konumlu */\r\n.slider-icon,\r\n.search-icon {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    font-size: 24px;\r\n}\r\n\r\n/* Slider (ayarlar) ikonu sağdan 70px boşluk */\r\n.slider-icon {\r\n    right: 70px;\r\n}\r\n\r\n/* Search (arama) ikonu sağdan 35px boşluk */\r\n.search-icon {\r\n    right: 35px;\r\n}\r\n\r\n/* Yeni: upload ikonu da mutlak konumlu ve dikey ortalanmış */\r\n.search-icons .upload-icon {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: #6b7280;\r\n    cursor: pointer;\r\n    font-size: 24px;\r\n}\r\n\r\n/* Upload ikonu sağdan 110px boşluk (Slider’ın solunda olacak şekilde) */\r\n.upload-icon {\r\n    right: 110px;\r\n}\r\n\r\n/* Aktif (paneli açık) hâlinde ikon rengi */\r\n.search-icons .upload-icon.active,\r\n.search-icons .slider-icon.active,\r\n.search-icons .search-icon.active {\r\n    color: #007bff;\r\n}\r\n\r\n\r\n/* Responsive Ayarlar */\r\n@media (max-width: 768px) {\r\n    .searchbar-container {\r\n        padding: 0 15px;\r\n    }\r\n\r\n    .search-input {\r\n        height: 48px;\r\n        font-size: 14px;\r\n        padding: 0 50px 0 15px;\r\n    }\r\n\r\n    .slider-icon,\r\n    .search-icon,\r\n    .upload-icon {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .slider-icon {\r\n        right: 50px;\r\n    }\r\n\r\n    .upload-icon {\r\n        right: 90px;  /* Responsive hâlinde biraz daha sola kaydırdık */\r\n    }\r\n\r\n    .search-icon {\r\n        right: 15px;\r\n    }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n    .searchbar-container {\r\n        padding: 0 10px;\r\n    }\r\n\r\n    .search-input {\r\n        height: 40px;\r\n        font-size: 14px;\r\n        padding: 0 45px 0 10px;\r\n    }\r\n\r\n    .slider-icon,\r\n    .search-icon,\r\n    .upload-icon {\r\n        font-size: 18px;\r\n    }\r\n\r\n    .slider-icon {\r\n        right: 45px;\r\n    }\r\n\r\n    .upload-icon {\r\n        right: 75px;  /* Mobilde daha solda */\r\n    }\r\n\r\n    .search-icon {\r\n        right: 15px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
